module.exports = __webpack_public_path__ + "static/media/downArrow.d5f641aa.svg";